import { supabaseClient } from "@/lib/database/supabase";
import fetchRunWithAssociations, { RunWithAssociations } from "@shared/lib/database/queries/fetchRunWithAssociations";
import { defineStore } from "pinia";
import { ref } from "vue";

export default defineStore("RunStore", () => {
  const runMap = ref<Map<string, RunWithAssociations | null>>(new Map());

  async function fetchRun (id: string) {
    const run = await fetchRunWithAssociations(supabaseClient, id);
    runMap.value.set(id, run);
    return run;
  }

  function getRun (id: string) {
    return runMap.value.get(id) || null;
  }

  function updateRun (id: string, run: Partial<RunWithAssociations>) {
    const existingRun = runMap.value.get(id);
    if (!existingRun) return;

    runMap.value.set(id, {
      ...existingRun,
      ...run,
    });

    return existingRun;
  }

  function removeRun (id: string) {
    runMap.value.delete(id);
  }

  return {
    getRun,
    fetchRun,
    updateRun,
    removeRun,
  };
});
